import { useField } from "formik";
import React, { CSSProperties } from "react";
import { Input } from "reactstrap";
import { IControlStyles, useControlStyles } from "../.";
import { LookupDto } from "../../../../../assets/utils/lib/lookupDto";
import { ControlProps } from "../../control";
import { ComponentProps, ControlTemplateProps } from "../misc/controlInput";

export interface ControlDropdownProps extends ControlTemplateProps {
    blankOption?: DropdownOption | undefined
    options?: DropdownOption[] | LookupDto[] | undefined
}

export interface DropdownOption {
    key: string,
    value: string,
    display: string
}

export const DropDownComponentProps = (props: ControlTemplateProps): ControlProps => {
    const componentProps = ComponentProps(props);
    delete componentProps.blankOption;
    delete componentProps.isHidden;

    return componentProps;
};


function MapOption(option: DropdownOption | LookupDto): DropdownOption {
    if (option instanceof LookupDto) {
        return {
            key: option.id as string,
            display: option.display as string,
            value: option.id as string,
        }
    }
    else {
        return option;
    }
}

export const ControlDropdown: React.FC<ControlDropdownProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();
    const [field, meta] = useField(props.name ?? "");
    const { onChange: fieldOnChange, value: fieldValue } = field;
    const [inputValue, setInputValue] = React.useState<any | undefined>(undefined);

    const options: DropdownOption[] = [];

    if (props.blankOption) {
        options.push(props.blankOption);
    }

    if (props.options && props.options.length > 0) {
        props.options?.map((item) => (
            options.push(MapOption(item))
        ))
    }

    const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.onChange) {
            props.onChange(e);
        }

        setInputValue(e.target.value)
        fieldOnChange(e);
    };

    React.useEffect(() => {
        setInputValue(fieldValue ?? props.value ?? undefined);
    }, [fieldValue, props.value]);

    const isHidden: boolean = props.isHidden ?? false;
    const inputStyle: CSSProperties | undefined = isHidden ? { display: "none" } : undefined;

    return (
        <>
            <Input type="select"
                {...DropDownComponentProps(props)}
                style={{ ...styles.dropdown ?? styles.text ?? styles.input, ...props.style, ...inputStyle }}
                placeholder={props.placeholder ?? ""}
                id={props.name}
                name={props.name}
                value={inputValue}
                onChange={handleChange}
                invalid={meta?.touched && !!meta?.error}
                className={`form-control ${meta?.error ? "is-invalid" : ""}`}
            >
                {options.map((item, index) => (
                    <option key={`${index}-${item.key}`} value={item.value}>
                        {item.display}
                    </option>
                ))}
            </Input>
            {meta?.error && <div className="invalid-feedback">{meta?.error}</div>}
        </>
    )
}